import { isPlaceholderConfig, type WidgetConfig } from '../config'

interface LeadCaptureStepProps {
  pardotUrl: string
  config: WidgetConfig
  onRestart: () => void
}

export function LeadCaptureStep({ pardotUrl, config, onRestart }: LeadCaptureStepProps) {
  const isPlaceholder = isPlaceholderConfig(config)

  return (
    <section className="wtta-step wtta-step--lead-capture" data-testid="lead-capture-step">
      <h2 className="wtta-title">Waar mogen wij jouw rapport heen sturen?</h2>
      <p className="wtta-lead">
        Vul hieronder jouw gegevens in. Je krijgt direct een persoonlijk rapport in jouw mailbox.
      </p>

      {isPlaceholder ? (
        <div className="wtta-warning" data-testid="config-warning" role="alert">
          <strong>Configuratie ontbreekt:</strong> de Pardot account- en form-id zijn nog niet
          ingesteld. Vraag jouw beheerder om <code>VITE_PARDOT_ACCOUNT_ID</code> en{' '}
          <code>VITE_PARDOT_FORM_ID</code> te configureren.
        </div>
      ) : (
        <iframe
          className="wtta-pardot-frame"
          data-testid="pardot-iframe"
          src={pardotUrl}
          title="WTTA quickscan rapport aanvragen"
          loading="lazy"
        />
      )}

      <button
        type="button"
        className="wtta-button wtta-button--ghost"
        onClick={onRestart}
        data-testid="restart-button"
      >
        Opnieuw beginnen
      </button>
    </section>
  )
}
